export const LOGINURL = "/signin";

export const LEFT_FILETERS_SIZE = [0, 1, 2, 3, 4, 5, 6, 7];
export const MORE_FILETERS_SIZE = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35,
];
export const PAGE_LENGTH = 10;
export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const CURRENCY_SYMBOL = "&#x20b9;";
export const errEnum = {
  SAVE_SEARCH_ERROR: "SAVE_SEARCH_ERROR",
  DOWNLOAD_ERROR: "DOWNLOAD_ERROR",
  SINGLE_COMPANY_TAG_ERROR: "SINGLE_COMPANY_TAG_ERROR",
  COMPANY_DETAILS_ERROR: "COMPANY_DETAILS_ERROR",
  EMPLOYEE_LIST_ERROR: "EMPLOYEE_LIST_ERROR",
  DEPARTMENT_LIST_ERROR: "DEPARTMENT_LIST_ERROR",
  SUBMIT_EXECUTIVE_LEAD_ERROR: "SUBMIT_EXECUTIVE_LEAD_ERROR",
  SIMILAR_COMPANYLIST_ERROR: "SIMILAR_COMPANYLIST_ERROR",
  SUBMIT_ERROR_FORM_ERROR: "SUBMIT_ERROR_FORM_ERROR",
  INDUSTRY_LIST_ERROR: "INDUSTRY_LIST_ERROR",
  COMPANY_TYPE_ERROR: "COMPANY_TYPE_ERROR",
  EMPLOYEE_COUNT_ERROR: "EMPLOYEE_COUNT_ERROR",
  REVENUE_RANGE_ERROR: "REVENUE_RANGE_ERROR",
  COMPANYLIST_ERROR: "COMPANYLIST_ERROR",
  ACCOUNTINFO_ERROR: "ACCOUNTINFO_ERROR",
  SAVE_SEARCH_LIST_ERROR: "SAVE_SEARCH_LIST_ERROR",
  COMPANY_TAG_LIST_ERROR: "COMPANY_TAG_LIST_ERROR",
  POST_RELAVANT_COMPANY_TAG: "POST_RELAVANT_COMPANY_TAG",
  GET_RELAVANT_COMPANY_TAG_ERROR: "GET_RELAVANT_COMPANY_TAG_ERROR",
  GET_EXECUTIVE_LEAD_ERROR: "GET_EXECUTIVE_LEAD_ERROR",
  GROUP_COMPANY_TAG_ERROR: "GROUP_COMPANY_TAG_ERROR",
  EXECUTIVE_LEVEL_LIST_ERROR: "EXECUTIVE_LEVEL_LIST_ERROR",
  EXECUTIVE_FUNCTION_LIST_ERROR: "EXECUTIVE_FUNCTION_LIST_ERROR",
  EXECUTIVE_DETAILS_ERROR: "EXECUTIVE_DETAILS_ERROR",
  EXECUTIVE_SIMILAR_COMPANYLIST_ERROR: "EXECUTIVE_SIMILAR_COMPANYLIST_ERROR",
  SUBSCRIPTIONACCOUNTINFO_ERROR: "SUBSCRIPTIONACCOUNTINFO_ERROR",
  EXECUTIVE_COMPANY_DETAILS: "EXECUTIVE_COMPANY_DETAILS",
  EMPLOYEE_VIEWABLE_STATUS: "EMPLOYEE_VIEWABLE_STATUS",
  LEAD_DETAILS_ERROR: "LEAD_DETAILS_ERROR",
  LEAD_DETAILS: "LEAD_DETAILS",
  EXECUTIVE_EMPLOYEE_VIEWABLE_STATUS_ERROR:
    "EXECUTIVE_EMPLOYEE_VIEWABLE_STATUS_ERROR",
  UPDATE_LEAD_DETAILS_ERROR: "UPDATE_LEAD_DETAILS_ERROR",
  SAVE_CLIENT_NOTE_ERROR: "SAVE_CLIENT_NOTE_ERROR",
  LEAD_REMARKS_ERROR: "LEAD_REMARKS_ERROR",
  LEAD_NOTE_DETAIL_ERROR: "LEAD_NOTE_DETAIL_ERROR",
  LEAD_STATUS_LIST_ERROR: "LEAD_STATUS_LIST_ERROR",
  DELETE_LEAD_NOTE_ERROR: "DELETE_LEAD_NOTE_ERROR",
  SAVE_CLIENT_REMARKS_ERROR: "SAVE_CLIENT_REMARKS_ERROR",
  UPDATEACCOUNTINFO_ERROR: "UPDATEACCOUNTINFO_ERROR",
  LEAD_EXECUTIVE_REMARKS: "LEAD_EXECUTIVE_REMARKS",
  LEAD_EXECUTIVE_REMARKS_ERROR: "LEAD_EXECUTIVE_REMARKS_ERROR",
  LEAD_TASKS_STATUS_LIST: "LEAD_TASKS_STATUS_LIST",
  LEAD_REMARK_CHIPS_ERROR: "LEAD_REMARK_CHIPS_ERROR",
  CLOSED_OPPORTUNITY_ERROR: "CLOSED_OPPORTUNITY_ERROR",
  DASHBOARD_GROUPED_COUNT_ERROR: "DASHBOARD_GROUPED_COUNT_ERROR",
  DASHBOARD_SALES_TREND_ERROR: "DASHBOARD_SALES_TREND_ERROR",
  DASHBOARD_GROUPED_BYSOURCE_ERROR: "DASHBOARD_GROUPED_BYSOURCE_ERROR",
  DASHBOARD_GROUPED_BYINDUSTRY_ERROR: "DASHBOARD_GROUPED_BYINDUSTRY_ERROR",
  DASHBOARD_GROUPED_BYACTIVITY_ERROR: "DASHBOARD_GROUPED_BYACTIVITY_ERROR",
  DASHBOARD_GROUPED_BYACTIVITY_STATUS_ERROR:
    "DASHBOARD_GROUPED_BYACTIVITY_STATUS_ERROR",
  COMPANYQUICKSELECTIONLIST_ERROR: "COMPANYQUICKSELECTIONLIST_ERROR",
  CREATED_LEAD_DETAILS_ERROR: "CREATED_LEAD_DETAILS_ERROR",
  MAILALERTINFO_ERROR: "MAILALERTINFO_ERROR",
  USAGEACCOUNTINFO_ERROR: "USAGEACCOUNTINFO_ERROR",
  UPDATEPASSWORDINFO_ERROR: "UPDATEPASSWORDINFO_ERROR",
  USAGELEADACCOUNTINFO_ERROR: "USAGELEADACCOUNTINFO_ERROR",
  FORGOTPASSWORDINFO_ERROR: "FORGOTPASSWORDINFO_ERROR",
  EXECUTIVEQUICKSELECTIONLIST: "EXECUTIVEQUICKSELECTIONLIST",
  RESETPASSWORDINFO_ERROR: "RESETPASSWORDINFO_ERROR",
  EXECUTIVE_DOWNLOAD_ERROR: "EXECUTIVE_DOWNLOAD_ERROR",
};

export const ErrKey = "title";
export const subscriptionContentInfo = {
  btntext: "SUBSCRIBE NOW!",
  content: "PLEASE SUBSCRIBE TO VIEW ALL DETAILS",
};

export const msgEnum = {
  PROFILE_UPDATE_MSG: "Information has been updated successfully.",
  PASSWORD_UPDATE_MSG: "Password has been updated successfully.",
  SUBSCRIPTION_SUCCESS_MSG: "Thanks for sign up for newsletter.",
  CONTACT_FORM_SUCCESS_MSG: "Thanks for contacting us!",
  LEAD_CREATION_MSG: "Lead has been created!",
  FORGOT_PASSWORD_MSG:
    "Reset Password Mail has been sent to your email ID. Kindly check your inbox.",
  RESET_PASSWORD_MSG: "Invalid secret key.",
};

export const subscriptionPlans = {
  trail: "Trial Plan",
  starter: "Starter Plan",
  growth: "Growth Plan",
  pro: "Pro Plan",
};

export const userRoles = { admin: "ADMIN" };

export const utmSource = "utm_source";

export const EventStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  UPCOMING: "UPCOMING",
};

export const MeetingType = {
  ZOOM: "ZOOM",
  GOOGLE_MEET: "GOOGLE_MEET",
  PHONE: "PHONE",
  IN_PERSON: "IN_PERSON",
};
